import type { NavigationItem } from '~/types';
import { PAGES_LEGAL } from '~/types';

export const NAVIGATION: NavigationItem[] = [
  { id: 1, label: 'Doctors', link: '/doctors', icon: 'stethoscope' },
  // { id: 2, label: 'For Patients', link: '/patients', icon: 'medical-shield' },
  { id: 3, label: 'Testimonials', link: '/testimonials', icon: 'speech-bubble' },
  { id: 4, label: 'Press', link: '/press', icon: 'newspaper' },
  { id: 5, label: 'Help Centre', link: '/help-centre', icon: 'question' },
];

export const LEGAL_NAVIGATION: NavigationItem[] = [
  // { id: 2, label: 'FAQs', link: '/help-centre/faqs' },
  { id: 1, label: 'Privacy Policy', link: `/${PAGES_LEGAL.HOME}/${PAGES_LEGAL.PRIVACY_POLICY}` },
  { id: 2, label: 'Cookies Policy', link: `/${PAGES_LEGAL.HOME}/cookies-policy` },
  { id: 3, label: 'Customer T&Cs', link: `/${PAGES_LEGAL.HOME}/customer-terms-conditions` },
  { id: 4, label: 'Vendor T&Cs', link: `/${PAGES_LEGAL.HOME}/vendor-terms-conditions` },
];
